module.exports = __webpack_public_path__ + "static/media/37.aad124c4.png";